import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import EvidenceTypeEnum from 'redpoints-model-js-common/enumeration/EvidenceTypeEnum';
import EnforcementStatusEnum from 'redpoints-model-js/enumeration/EnforcementStatusEnum';

import { Loader } from 'redpoints-front-components/index';
import { Tabs } from 'redpoints-front-components/index';

import { getIncidentDetailsEvidencePermissions } from '../../../reducers/reporting/incidentDetails';
import IncidentDetailsEvidencesTabContent from './IncidentDetailsEvidencesTabContent';
import { translate } from '../../../helpers/languageHelper';

const CLOSED_ENFORCEMENT_STATUS = [
  EnforcementStatusEnum.CLOSED.name,
  EnforcementStatusEnum.ENFORCED.name,
];

const OPENED_EVIDENCE = 'openEvidence';
const CLOSED_EVIDENCE = 'closeEvidence';

const IncidentDetailsEvidences = ({
  canEditEvidences,
  enforcementStatus,
  evidenceChange,
  evidenceValidate,
  evidences,
  isLoading,
  isMandatory,
}) => {
  const opened = evidences.find(
    type => type.evidenceType.name === EnforcementStatusEnum.OPEN.name
  );
  const closed = evidences.find(
    type => type.evidenceType.name === EnforcementStatusEnum.CLOSED.name
  );

  const shouldShowClosedEvidenceTab = CLOSED_ENFORCEMENT_STATUS.includes(
    enforcementStatus?.name
  );

  const defaultActiveTab = shouldShowClosedEvidenceTab
    ? CLOSED_EVIDENCE
    : OPENED_EVIDENCE;

  const [tab, setTab] = useState(defaultActiveTab);
  const isEditable = canEditEvidences && defaultActiveTab === tab;
  const mandatory = isEditable ? isMandatory : false;

  const handleTabChange = activeKey => setTab(activeKey);

  return (
    <div className="incident-details-evidences-container">
      <h3>{translate('reporting.incidentDetails.evidence.title')}</h3>
      <Loader isLoading={isLoading}>
        <Tabs
          activeKey={tab}
          onChange={handleTabChange}
          aria-label="tabs-container"
        >
          <Tabs.TabPane
            tab={translate('reporting.incidentDetails.evidence.tabs.open')}
            key={OPENED_EVIDENCE}
          >
            <IncidentDetailsEvidencesTabContent
              evidence={opened}
              evidenceChange={evidenceChange}
              evidenceType={EvidenceTypeEnum.OPEN}
              evidenceValidate={evidenceValidate}
              isEditable={isEditable}
              isMandatory={mandatory}
            />
          </Tabs.TabPane>
          {shouldShowClosedEvidenceTab && (
            <Tabs.TabPane
              tab={translate('reporting.incidentDetails.evidence.tabs.close')}
              key={CLOSED_EVIDENCE}
            >
              <IncidentDetailsEvidencesTabContent
                evidence={closed}
                evidenceChange={evidenceChange}
                evidenceType={EvidenceTypeEnum.CLOSED}
                evidenceValidate={evidenceValidate}
                isEditable={isEditable}
                isMandatory={mandatory}
              />
            </Tabs.TabPane>
          )}
        </Tabs>
      </Loader>
    </div>
  );
};

const mapStateToProps = state => ({
  canEditEvidences: getIncidentDetailsEvidencePermissions(state),
});

export default compose(connect(mapStateToProps))(IncidentDetailsEvidences);
